import React, { ReactNode } from "react"
import { Box, Stack, Text } from "@chakra-ui/react"
import InfoSegment from "../InfoSegment"

type Props = {
  title: string
  children: ReactNode
}

const MessageScreen = ({ title, children }: Props) => (
  <>
    <InfoSegment />
    <Stack spacing={5} textAlign="center">
      <Box mt={2} mb={6}>
        <Text fontWeight="semibold">{title}</Text>
        <Text>{children}</Text>
      </Box>
    </Stack>
  </>
)

export default MessageScreen
